import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Bell } from 'shared/assets/icons';
import { TimePickerMenu } from 'shared/components/ui/time-picker-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { TimeFormatOptions } from 'shared/types/date-format-options';
import { parseDateTime } from 'shared/utils/parse-date-time';

import { MetaInteraction } from '../meta-interaction/meta-interaction';

export type MetaReminderProps = {
  timeFormat: TimeFormatOptions;
  value?: number | null;
  onChange?: (time?: number) => void;
};

export const MetaReminder: React.FC<MetaReminderProps> = ({
  timeFormat,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const parsedValue = useMemo(
    () => (value ? parseDateTime(value, timeFormat) : undefined),
    [timeFormat, value],
  );

  const _onChange = (time?: number) => {
    onChange?.(time);
    closeMenu();
  };

  const onClear = () => {
    onChange?.();
    closeMenu();
  };

  return (
    <>
      <MetaInteraction
        ref={buttonRef}
        icon={Bell}
        onClick={openMenu}
        placeholder={t('dialogs.task-detail.meta.reminder.placeholder')}
        label={parsedValue}
        onClear={parsedValue ? onClear : undefined}
      />
      {menuOpen && (
        <TimePickerMenu
          referenceElement={buttonRef}
          timeFormat={timeFormat}
          value={value}
          onChange={_onChange}
          onCancel={closeMenu}
          optionIcon={Bell}
          hasCustomInput
          canClear
        />
      )}
    </>
  );
};
